import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { AreaHeaderComponent } from "@odx/angular/components/area-header";
import { ButtonComponent } from "@odx/angular/components/button";
import { ModalRef } from "@odx/angular/components/modal";

@Component({
  selector: "app-discard-group-modal",
  imports: [AreaHeaderComponent, UiKitModule, ButtonComponent],
  templateUrl: "./discard-group-modal.component.html",
})
export class DiscardGroupModalComponent {
  public readonly modalRef = inject(ModalRef);

  onConfirm() {
    this.modalRef.close(true);
  }
}
